import { commonApi } from '@exchange-frontends/api';

import CallError from '../../utils/CallError';
import { getBadParams, getMissingKeys } from '../../utils/general';

/**
 * Checks if the user is part of the app org
 * @param {object} params - an object of params
 * @param {string} params.accessToken - User IMS token
 * @param {string} params.appId - Id of the app
 * @param {string} params.imsUserId - User id
 * @param {string} params.imsEmail - User email
 */
export default async (params = {}, signal = null) => {
  const requiredParams = ['appId', 'accessToken', 'imsUserId', 'imsEmail'];
  const paramsRules = {
    appId: { allowedTypes: ['string'] },
    accessToken: { allowedTypes: ['string'] },
    imsUserId: { allowedTypes: ['string'] },
    imsEmail: { allowedTypes: ['string'] },
  };
  const missingParams = getMissingKeys(params, requiredParams);
  let badParams = [];
  if (Object.keys(params).length) {
    badParams = getBadParams(params, paramsRules);
  }
  if (missingParams.length || badParams.length) {
    throw new CallError('params', null, 404, { missingParams, badParams });
  }
  const response = await fetch(
    `${commonApi.ccesSettings.endpoint}/extensions/${params.appId}/validate?check=ownership`,
    {
      signal,
      method: 'GET',
      headers: {
        accept: 'application/vnd.adobe-ccextension.extension-validation-v1+json',
        Authorization: params.accessToken,
        'x-gw-ims-user-id': params.imsUserId,
        'x-gw-ims-email': params.imsEmail,
        'x-api-key': commonApi.ccesSettings.apiKey,
      },
    }
  );

  let content = await response.text();
  try {
    content = JSON.parse(content);
  } catch (e) {
    // response is not json
  }

  return content?.owner || false;
};
